module.exports = __webpack_public_path__ + "static/cryptickiller-bf0bcce239ed08b0f009bc4cdbb2c14e.jpg";